module.exports = __webpack_public_path__ + "img/prod-hob.7fb242b5.jpg";